<template>
  <swiper-slide class="swiper4">
    <head-bar :main_title="main_title"></head-bar>
    <canvas id="c"></canvas>
    <div class="contanier">
      <div class="topBox">
        <div class="top" v-show="active == 0">
          <div class="topImg">
            <img src="../assets/hy1.png" width="100%" alt="" />
          </div>
        </div>
        <div class="top" v-show="active == 1">
          <div class="topImg">
            <img src="../assets/hy2.png" width="100%" alt="" />
          </div>
        </div>
        <div class="top" v-show="active == 2">
          <div class="topImg">
            <img src="../assets/hy3.png" width="100%" alt="" />
          </div>
        </div>
        <div class="top" v-show="active == 3">
          <div class="topImg">
            <img src="../assets/hy4.png" width="100%" alt="" />
          </div>
        </div>
        <div class="top" v-show="active == 4">
          <div class="topImg">
            <img src="../assets/hy5.png" width="100%" alt="" />
          </div>
        </div>
        <div class="pie">
          <img src="../assets/pie.png" width="100%" alt="" />
        </div>
      </div>

      <div class="bottom">
        <div class="center">
          <div class="c_b">
            <img src="../assets/dz.png" alt="" />
            <div class="cir1"><img src="../assets/cirL.png" alt="" /></div>
            <div class="cir2"><img src="../assets/cirR.png" alt="" /></div>
            <div class="txt">
              <p>5项</p>
              <p>行业数据模型</p>
            </div>
          </div>
        </div>
        <div>
          <div
            class="item"
            v-for="(item, index) in tabArr"
            :key="index"
            @click="changeActive(index)"
            @mouseenter="removetimeName"
            @mouseleave="timeR"
            :class="active == index ? 'colorActive' : ''"
          >
            <img
              width="100%"
              :src="require('../assets/' + item.default)"
              :class="active == index ? 'moveActive' : ''"
            />
            <p>{{ item.title }}</p>
          </div>
        </div>
      </div>
    </div>
  </swiper-slide>
</template>
<script>
import { TweenMax } from "gsap";
import headBar from "../components/headBar.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/css/swiper.min.css";
import echarts from "echarts";
import { echartsCancelLoop } from "../util/echarts-auto-tooltip";
export default {
  name: "industryData",
  components: {
    swiper,
    swiperSlide,
    headBar,
  },
  data() {
    return {
      main_title: require("../assets/title3.png"),
      active: 0,
      timeName: "",
      tabArr: [
        {
          title: "电商行业",
          default: "industry1_active.png",
        },
        {
          title: "快消行业",
          default: "industry2.png",
        },
        {
          title: "数字政府",
          default: "industry3.png",
        },
        {
          title: "汽车行业",
          default: "industry4.png",
        },
        {
          title: "文创行业",
          default: "industry5.png",
        },
      ],
    };
  },
  mounted() {
    this.timeR();
    this.init();
  },
  beforeDestroy() {
    if (this.timeName) {
      clearInterval(this.timeName); // 在Vue实例销毁前，清除我们的定时器
    }
  },
  methods: {
    //canvas
    init() {
      function random(low, high) {
        return Math.random() * (high - low) + low;
      }
      class Visual {
        constructor() {
          this.canvas = document.querySelector("#c");
          this.context = this.canvas.getContext("2d");
          this.canvasWidth = 0;
          this.canvasHeight = 0;
          this.particleLength = 150;
          this.particles = [];
          this.particleMaxRadius = 8;

          this.handleMouseMoveBind = this.handleMouseMove.bind(this);
          this.handleClickBind = this.handleClick.bind(this);
          this.handleResizeBind = this.handleResize.bind(this);

          this.initialize();
          this.render();
        }

        initialize() {
          this.resizeCanvas();
          for (let i = 0; i < this.particleLength; i++) {
            this.particles.push(this.createParticle(i));
          }
          this.bind();
        }

        bind() {
          document.body.addEventListener(
            "mousemove",
            this.handleMouseMoveBind,
            false
          );
          document.body.addEventListener("click", this.handleClickBind, false);
          window.addEventListener("resize", this.handleResizeBind, false);
        }

        unbind() {
          document.body.removeEventListener(
            "mousemove",
            this.handleMouseMoveBind,
            false
          );
          document.body.removeEventListener(
            "click",
            this.handleClickBind,
            false
          );
          window.removeEventListener("resize", this.handleResizeBind, false);
        }

        handleMouseMove(e) {
          this.enlargeParticle(e.clientX, e.clientY);
        }

        handleClick(e) {
          this.burstParticle(e.clientX, e.clientY);
        }

        handleResize() {
          this.resizeCanvas();
        }

        resizeCanvas() {
          this.canvasWidth = document.body.offsetWidth;
          this.canvasHeight = document.body.offsetHeight;
          this.canvas.width = this.canvasWidth * window.devicePixelRatio;
          this.canvas.height = this.canvasHeight * window.devicePixelRatio;
          this.context = this.canvas.getContext("2d");
          this.context.scale(window.devicePixelRatio, window.devicePixelRatio);
        }

        createParticle(id, isRecreate) {
          const radius = random(1, this.particleMaxRadius);
          const x = isRecreate
            ? -radius - random(this.particleMaxRadius * 2, this.canvasWidth)
            : random(0, this.canvasWidth);
          let y = random(
            this.canvasHeight / 2 - 150,
            this.canvasHeight / 2 + 150
          );
          y += random(-100, 100);
          const alpha = random(0.05, 1);

          return {
            id: id,
            x: x,
            y: y,
            startY: y,
            radius: radius,
            defaultRadius: radius,
            startAngle: 0,
            endAngle: Math.PI * 2,
            alpha: alpha,
            color: { r: 60, g: 196, b: 228 },
            speed: alpha + 1,
            amplitude: random(50, 200),
            isBurst: false,
          };
        }

        drawParticles() {
          this.particles.forEach((particle) => {
            // 浣嶇疆鎯呭牨鏇存柊
            this.moveParticle(particle);

            // particle鎻忕敾
            this.context.beginPath();
            this.context.fillStyle = `rgba(${particle.color.r}, ${particle.color.g}, ${particle.color.b}, ${particle.alpha})`;
            this.context.arc(
              particle.x,
              particle.y,
              particle.radius,
              particle.startAngle,
              particle.endAngle
            );
            this.context.fill();
          });
        }

        moveParticle(particle) {
          particle.x += particle.speed;
          particle.y =
            particle.startY +
            particle.amplitude * Math.sin(((particle.x / 5) * Math.PI) / 180);
        }

        enlargeParticle(clientX, clientY) {
          this.particles.forEach((particle) => {
            if (particle.isBurst) return;

            const distance = Math.hypot(
              particle.x - clientX,
              particle.y - clientY
            );

            if (distance <= 100) {
              const scaling = (100 - distance) / 1.5;
              TweenMax.to(particle, 0.5, {
                radius: particle.defaultRadius + scaling,
                // ease: Power2.easeOut
              });
            } else {
              TweenMax.to(particle, 0.5, {
                radius: particle.defaultRadius,
                // ease: Power2.easeOut
              });
            }
          });
        }

        burstParticle(clientX, clientY) {
          this.particles.forEach((particle) => {
            const distance = Math.hypot(
              particle.x - clientX,
              particle.y - clientY
            );

            if (distance <= 100) {
              particle.isBurst = true;
              TweenMax.to(particle, 0.5, {
                radius: particle.defaultRadius + 200,
                alpha: 0,
                // ease: Power2.easeOut,
                onComplete: () => {
                  this.particles[particle.id] = this.createParticle(
                    particle.id,
                    true
                  );
                },
              });
            }
          });
        }

        render() {
          this.context.clearRect(
            0,
            0,
            this.canvasWidth + this.particleMaxRadius * 2,
            this.canvasHeight
          );
          this.drawParticles();
          this.particles.forEach((particle) => {
            if (particle.x - particle.radius >= this.canvasWidth) {
              this.particles[particle.id] = this.createParticle(
                particle.id,
                true
              );
            }
          });

          requestAnimationFrame(this.render.bind(this));
        }
      }
      new Visual();
    },
    changeActive(index) {
      var that = this;
      that.active = index;
      switch (index) {
        case 0:
          that.tabArr[0].default = "industry1_active.png";
          that.tabArr[1].default = "industry2.png";
          that.tabArr[2].default = "industry3.png";
          that.tabArr[3].default = "industry4.png";
          that.tabArr[4].default = "industry5.png";
          break;
        case 1:
          that.tabArr[1].default = "industry2_active.png";
          that.tabArr[0].default = "industry1.png";
          that.tabArr[2].default = "industry3.png";
          that.tabArr[3].default = "industry4.png";
          that.tabArr[4].default = "industry5.png";
          break;
        case 2:
          that.tabArr[2].default = "industry3_active.png";
          that.tabArr[1].default = "industry2.png";
          that.tabArr[0].default = "industry1.png";
          that.tabArr[3].default = "industry4.png";
          that.tabArr[4].default = "industry5.png";
          break;
        case 3:
          that.tabArr[3].default = "industry4_active.png";
          that.tabArr[1].default = "industry2.png";
          that.tabArr[2].default = "industry3.png";
          that.tabArr[0].default = "industry1.png";
          that.tabArr[4].default = "industry5.png";
          break;
        case 4:
          that.tabArr[4].default = "industry5_active.png";
          that.tabArr[1].default = "industry2.png";
          that.tabArr[2].default = "industry3.png";
          that.tabArr[3].default = "industry4.png";
          that.tabArr[0].default = "industry1.png";
          break;
      }
    },
    timeR() {
      var that = this;
      that.timeName = setInterval(() => {
        if (that.active < 4) {
          that.active++;
          // console.log(this.active);
        } else {
          that.active = 0;
        }
        this.changeActive(that.active);
        switch (that.active) {
          case 0:
            that.tabArr[0].default = "industry1_active.png";
            that.tabArr[1].default = "industry2.png";
            that.tabArr[2].default = "industry3.png";
            that.tabArr[3].default = "industry4.png";
            that.tabArr[4].default = "industry5.png";
            break;
          case 1:
            that.tabArr[1].default = "industry2_active.png";
            that.tabArr[0].default = "industry1.png";
            that.tabArr[2].default = "industry3.png";
            that.tabArr[3].default = "industry4.png";
            that.tabArr[4].default = "industry5.png";

            break;
          case 2:
            that.tabArr[2].default = "industry3_active.png";
            that.tabArr[1].default = "industry2.png";
            that.tabArr[0].default = "industry1.png";
            that.tabArr[3].default = "industry4.png";
            that.tabArr[4].default = "industry5.png";
            break;
          case 3:
            that.tabArr[3].default = "industry4_active.png";
            that.tabArr[1].default = "industry2.png";
            that.tabArr[2].default = "industry3.png";
            that.tabArr[0].default = "industry1.png";
            that.tabArr[4].default = "industry5.png";
            break;
          case 4:
            that.tabArr[4].default = "industry5_active.png";
            that.tabArr[1].default = "industry2.png";
            that.tabArr[2].default = "industry3.png";
            that.tabArr[3].default = "industry4.png";
            that.tabArr[0].default = "industry1.png";
            break;
        }
      }, 5000);
    },
    removetimeName() {
      clearInterval(this.timeName);
    },
    moveIn() {
      clearInterval(this.timeName);
    },
  },
  created() {},
};
</script>
<style lang="less" scoped>
@import "../style/industry.less";
</style>